import { render } from "./ContactsView.vue?vue&type=template&id=49e366df"
import script from "./ContactsView.vue?vue&type=script&lang=js"
export * from "./ContactsView.vue?vue&type=script&lang=js"

import "./ContactsView.vue?vue&type=style&index=0&id=49e366df&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__